// extracted by mini-css-extract-plugin
export var screen1 = "style-module--screen1--28267";
export var screen1Btn = "style-module--screen1-btn--4966e";
export var screen1BtnNoactive = "style-module--screen1-btn--noactive--f3ef7";
export var screen1_subtitle = "style-module--screen1_subtitle--4e147";
export var screen1_suptitle = "style-module--screen1_suptitle--0a7d6";
export var screen1_title = "style-module--screen1_title--affc5";